/* request Price Match Modal JS */
(function () {
  var modal = document.getElementById('PriceMatchModal');
  if (!modal) return;

  var body = document.body;
  var openBtns = document.querySelectorAll('.pm-trigger');
  var closeEls = modal.querySelectorAll('[data-pm-close]');

  function openModal() {
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    body.classList.add('pm-modal-open');
  }

  function closeModal() {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    body.classList.remove('pm-modal-open');
  }

  openBtns.forEach(function (btn) { btn.addEventListener('click', openModal); });
  closeEls.forEach(function (el) { el.addEventListener('click', closeModal); });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
  });
})();